import { Button, Menu, MenuButton, MenuItem, MenuList, useDisclosure } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { HiChevronDown } from 'react-icons/hi';

import { CancelBookingModal } from './CancelBookingModal';
import { UpdateTenderDateModal } from './UpdateTenderDateModal';

type Props = { requestId: number; refetchQuote: () => void };

export const ModifyButton = ({ requestId, refetchQuote }: Props) => {
  const changeTenderDateModal = useDisclosure();
  const cancelBookingModal = useDisclosure();

  return (
    <>
      <Menu>
        <MenuButton colorScheme="secondary" rightIcon={<HiChevronDown />} as={Button}>
          Modify
        </MenuButton>
        <MenuList>
          <MenuItem onClick={changeTenderDateModal.onOpen}>Change Tender Date</MenuItem>
          <MenuItem color="error" onClick={cancelBookingModal.onOpen}>
            Cancel Booking
          </MenuItem>
        </MenuList>
      </Menu>

      <Show if={changeTenderDateModal.isOpen}>
        <UpdateTenderDateModal
          requestId={requestId}
          refetch={refetchQuote}
          isOpen={changeTenderDateModal.isOpen}
          onClose={changeTenderDateModal.onClose}
        />
      </Show>
      <Show if={cancelBookingModal.isOpen}>
        <CancelBookingModal
          requestId={requestId}
          refetch={refetchQuote}
          isOpen={cancelBookingModal.isOpen}
          onClose={cancelBookingModal.onClose}
        />
      </Show>
    </>
  );
};
